define("shared/components/shared/post/secondary/toggle", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{@class}}>
    <div class="cPM--composerTool__divider"></div>
    {{! Saved Captions }}
    <Shared::Ui::Button
      @class={{concat-classes
        "cPM--composerTool__item qa--savedCaptionBtn"
        (if this.isSavedCaptionsActive "is--active")
        (if @isFirstComment "qa--fc_add_savedCaption")
      }}
      @isDisabled={{@isDisabled}}
      @variant="unstyled"
      {{on "click" this.toggleSavedCaptions}}
    >
      {{svg-jar "template" class="o--icon--sm"}}
      <span data-test-id="captions-toggle">
        {{t "post.body.saved_captions"}}
      </span>
    </Shared::Ui::Button>
    {{! Hashtag Suggestions }}
    {{#if this.showHashtagSuggestions}}
      <Shared::Ui::Button
        @class={{concat-classes
          "cPM--composerTool__item qa--hashtagSuggestionsBtn at--onboardingV1__hashtagSuggestions at--hashtagAnalyticsUpgrade__hashtagSuggestionBtn"
          (if this.isHashtagSuggestionsActive "is--active")
          (if @isFirstComment "qa--fc_add_hashtags")
        }}
        @isDisabled={{@isDisabled}}
        @variant="unstyled"
        {{on "click" this.toggleHashtagSuggestions}}
      >
        {{svg-jar "smart-hashtag" class="o--icon--sm"}}
        <span class="qa--hashtagSuggestions_suggestBtn" data-test-id="hashtags-toggle">
          {{t "shared_phrases.hashtag_suggestions"}}
        </span>
      </Shared::Ui::Button>
    {{/if}}
  </div>
  */
  {
    "id": "7eaMYN3C",
    "block": "[[[10,0],[15,0,[30,1]],[12],[1,\"\\n  \"],[10,0],[14,0,\"cPM--composerTool__divider\"],[12],[13],[1,\"\\n\"],[1,\"  \"],[8,[39,0],[[4,[38,3],[\"click\",[30,0,[\"toggleSavedCaptions\"]]],null]],[[\"@class\",\"@isDisabled\",\"@variant\"],[[28,[37,1],[\"cPM--composerTool__item qa--savedCaptionBtn\",[52,[30,0,[\"isSavedCaptionsActive\"]],\"is--active\"],[52,[30,2],\"qa--fc_add_savedCaption\"]],null],[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,4],[\"template\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n    \"],[10,1],[14,\"data-test-id\",\"captions-toggle\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"post.body.saved_captions\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[30,0,[\"showHashtagSuggestions\"]],[[[1,\"    \"],[8,[39,0],[[4,[38,3],[\"click\",[30,0,[\"toggleHashtagSuggestions\"]]],null]],[[\"@class\",\"@isDisabled\",\"@variant\"],[[28,[37,1],[\"cPM--composerTool__item qa--hashtagSuggestionsBtn at--onboardingV1__hashtagSuggestions at--hashtagAnalyticsUpgrade__hashtagSuggestionBtn\",[52,[30,0,[\"isHashtagSuggestionsActive\"]],\"is--active\"],[52,[30,2],\"qa--fc_add_hashtags\"]],null],[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"smart-hashtag\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[10,1],[14,0,\"qa--hashtagSuggestions_suggestBtn\"],[14,\"data-test-id\",\"hashtags-toggle\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"shared_phrases.hashtag_suggestions\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"@class\",\"@isFirstComment\",\"@isDisabled\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"on\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/toggle.hbs",
    "isStrictMode": false
  });
  let ToggleComponent = _exports.default = (_class = class ToggleComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor2, this);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isHashtagSuggestionsActive() {
      return this.secondaryModal.isHashtagSuggestionsModalActive(this.args.postElementId, this.args.targetLocation);
    }
    get isSavedCaptionsActive() {
      return this.secondaryModal.isSavedCaptionsModalActive(this.args.postElementId, this.args.targetLocation);
    }
    get showHashtagSuggestions() {
      if (this.args.mediaItem) {
        return true;
      }
      const validCaption = !this.args.post?.exceededHashtagLimit && !this.args.post?.exceededCharacterLimit;
      const validSocialProfile = this.args.posts?.any(post => this._canHashtagSuggestions(post.get('socialProfile'))) || this.args.post && this._canHashtagSuggestions(this.args.post.socialProfile);
      return validCaption && validSocialProfile;
    }
    _canHashtagSuggestions(socialProfile) {
      if (socialProfile?.get('isTiktok') || socialProfile?.get('isPinterest') || socialProfile?.get('isLinkedin')) {
        return false;
      }
      return true;
    }
    toggleHashtagSuggestions() {
      if (!this.args.isDisabled) {
        this.args.toggleHashtagSuggestions();
      }
    }
    toggleSavedCaptions() {
      if (!this.args.isDisabled) {
        this.args.toggleSavedCaptions();
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleHashtagSuggestions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHashtagSuggestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSavedCaptions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSavedCaptions"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ToggleComponent);
});